import React from "react";

import * as adminLayoutActions from "modules/adminLayout/actionCreator";

import { Newsletter, SaveNewsletterModelStateErrors } from "modules/newsletters/models"
import { NewsletterTemplate, SaveNewsletterModel } from "modules/newsletters";
import { GlobalApplicationState } from "globalApplicationState";
import { ConnectedProps, connect } from "react-redux";
import { HeaderAndFooter } from "./headerAndFooter";

const HeaderAndFooterNewsletterPageComponent: React.FunctionComponent<PropsWithRedux> = ({
    emailTemplate,
    isLoadingFooterImage,
    isLoadingHeaderImage,
    newsletter,
    headerImage,
    footerImage,
    defaultLcid,
    currentLcid,
    setImage,
    setHeaderStyle,
    setMainStyle,
    onError,
    onNewsletterChange,
    clearImage,
}) => {

    const onChangeNewsletter = (value: Partial<Newsletter>) => {
        onNewsletterChange(value);
    }

    const onHeaderChange = (event) => {
        let currentContent = newsletter.translatedContent;
        currentContent[currentLcid].header = event;
        onChangeNewsletter({ emailTemplateHeaderText: event, translatedContent: currentContent });
    }

    const onBodyChange = (event) => {
        let currentContent = newsletter.translatedContent;
        currentContent[currentLcid].body = event;
        onChangeNewsletter({ bodyText: event, translatedContent: currentContent });
    }

    const onFooterChange = (event) => {
        let currentContent = newsletter.translatedContent;
        currentContent[currentLcid].footer = event;
        onChangeNewsletter({ emailTemplateFooterText: event, translatedContent: currentContent });
    }

    const onFullscreen = (isFullscreen: boolean) => {
        if (isFullscreen) {
            // one more than side nav bar
            setMainStyle({ zIndex: 3 });
            setHeaderStyle({ display: "none" });
        } else {
            setMainStyle(undefined);
            setHeaderStyle(undefined);
        }
    }

    return (
        <>
            <div style={{ marginTop: 30, marginBottom: 30 }}>
                <HeaderAndFooter
                    headerImage={headerImage}
                    footerImage={footerImage}
                    isLoadingFooterImage={isLoadingFooterImage}
                    isLoadingHeaderImage={isLoadingHeaderImage}
                    setImage={setImage}
                    clearImage={clearImage}
                    onError={onError} 
                    isCustomTemplate={emailTemplate.isCustom} 
                    headerImageHeight={emailTemplate.headerImageHeight} 
                    headerImageWidth={emailTemplate.headerImageWidth} 
                    footerImageHeight={emailTemplate.footerImageHeight} 
                    footerImageWidth={emailTemplate.footerImageWidth} 
                    header={newsletter.translatedContent[currentLcid].header || ""} 
                    footer={newsletter.translatedContent[currentLcid].footer || ""} 
                    body={newsletter.translatedContent[currentLcid].body || ""} 
                    defaultLcid={defaultLcid} 
                    onBodyChange={onBodyChange} 
                    onHeaderChange={onHeaderChange} 
                    onFooterChange={onFooterChange} 
                    onFullscreen={onFullscreen}                    
                />
            </div>
        </>
    );
}

interface HeaderAndFooterNewsletterPageProps {
    newsletter: SaveNewsletterModel;
    emailTemplate: NewsletterTemplate;
    modelErrors: SaveNewsletterModelStateErrors | null;
    footerImage?: File | null;
    headerImage?: File | null;
    isLoadingFooterImage?: boolean;
    isLoadingHeaderImage?: boolean;
    highlight: boolean;
    currentLcid: string;
    changedSinceSaved: boolean;
    onNewsletterChange: (value: Partial<SaveNewsletterModel>) => void;
    setImage: (imageType: string, image?: File) => void;
    clearImage?: (imageType: string) => void;
    onError: (message: string) => any;
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: HeaderAndFooterNewsletterPageProps) => ({
        ...ownProps,
        defaultLcid: state.settings.tenantSettings.defaultLCID,
    }),
    {
        setMainStyle: adminLayoutActions.setMainStyle,
        setHeaderStyle: adminLayoutActions.setHeaderStyle,
    }
);

type PropsWithRedux = ConnectedProps<typeof connector>;
export const HeaderAndFooterNewsletterPage = connector(HeaderAndFooterNewsletterPageComponent);
